import { TableCompData } from "../../../../components";
import EmptyTable from "../../../../components/Common/EmptyTable";
import { SettingBranchHeader } from "../../../../utils/TableHeader/SettingBranchHeader";
import {
  useGetBranchesQuery,
  selectBranchesData,
} from "../../../../store/admin/settings/branchSlice";
import { useSelector } from "react-redux";

export default function AllBranch({ TableDropDown, onSubmit }) {
  const { isFetching, isError, error } = useGetBranchesQuery();
  const branches = useSelector(selectBranchesData);
  if (isError) {
    console.log(error);
    return <p>An error occurred</p>;
  }

  return (
    <div>
      <h4 className=" text-black1 fw-bold">Branch List</h4>
      <TableCompData
        data={branches}
        marginBottom={"120px"}
        columns={SettingBranchHeader(TableDropDown)}
        message={
          isFetching ? (
            <div className="py-4">loading...</div>
          ) : (
            <div className="pt-4">
              <EmptyTable
                Message={
                  "Branch lists is empty, your created branches will appear here"
                }
              />
            </div>
          )
        }
      />
    </div>
  );
}
